import { SVGProps } from 'react';

const WrapText = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m16 20-2-2 2-2m-2 2h4a3 3 0 0 0 0-6H3m0 6h7M3 6h18"
    />
  </svg>
);
export default WrapText;
